import axios from "../axiosInstance";

const warehouseAPI = {
  list: (params) => axios.get("warehouses/", { params }),

  getLocations: () => axios.get("warehouses/locations"),

  addDetails: (payload) => axios.post("warehouses/", payload),

  deleteItem: (id) => axios.delete(`warehouses/${id}`),
};

export default warehouseAPI;
